import Vue from "vue";
import App from "./App.vue";
import "./styles/index.scss";
import "./styles/theme.scss";
import "./styles/element.scss";
import "./styles/rem.scss";
import "./assets/icons"; //svg

import Element from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import router from "./router";
import store from "./store";
import directive from "./directive"; // directive
import CommonTable from "@/components/CommonTable";
import ImageUpload from "@/components/ImageUpload";
import Pagination from "@/components/Pagination";
import myTitle from "@/components/myTitle";

Vue.prototype.$log = window.console.log;
Vue.prototype.$msgSuccess = function(msg) {
  this.$message({
    showClose: true,
    message: msg,
    type: "success",
  });
};

Vue.prototype.$msgError = function(msg) {
  this.$message({
    showClose: true,
    message: msg,
    type: "error",
  });
};

Vue.prototype.$msgInfo = function(msg) {
  this.$message.info(msg);
};

Element.Dialog.props.closeOnClickModal.default = false;

Vue.use(Element, {
  size: "mini",
});
Vue.use(directive);

Vue.component("CommonTable", CommonTable);
Vue.component("ImageUpload", ImageUpload);
Vue.component("Pagination", Pagination);
Vue.component("myTitle", myTitle);

Vue.config.productionTip = false;

new Vue({
  el: "#app",
  router,
  store,
  render: h => h(App),
});
